import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AdminPage() {
    const [users, setUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const navigate = useNavigate();

    // ✅ 모달 알림 상태 추가
    const [statusModal, setStatusModal] = useState({ visible: false, message: '', type: 'normal' });

    const triggerStatus = (msg, type = 'normal') => {
        setStatusModal({ visible: true, message: msg, type: type });
    };

    // ✅ 전체 유저 목록 불러오기
    const fetchUsers = async () => {
        try {
            const response = await fetch('https://campus-life-production.up.railway.app/api/admin/users', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                console.error('유저 목록 로드 실패');
            }
        } catch (error) {
            console.error('백엔드 서버 연결 실패!');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    // ✅ 회원 정보 수정 저장 (인증 헤더 추가 및 알림 모달 연결)
    const handleSave = async () => {
        try {
            const response = await fetch(`https://campus-life-production.up.railway.app/api/admin/users/${editingUser.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    // ✅ 인증 정보가 필요한 경우를 위해 토큰 추가
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(editingUser),
            });

            if (response.ok) {
                setUsers(users.map(u => u.id === editingUser.id ? editingUser : u));
                setIsModalOpen(false);
                triggerStatus('회원 정보가 성공적으로 수정되었습니다.', 'normal');
            } else {
                triggerStatus('수정에 실패했습니다. 서버 권한을 확인해주세요.', 'error');
            }
        } catch (error) {
            triggerStatus('백엔드 서버 연결 실패!', 'error');
        }
    };

    // ✅ 계정 삭제 (알림 모달 연결)
    const handleDelete = async (userId) => {
        // window.confirm은 기본 브라우저 기능이므로 유지하거나 필요시 커스텀 가능
        if (window.confirm(`정말 이 계정을 삭제하시겠습니까?`)) {
            try {
                const response = await fetch(`https://campus-life-production.up.railway.app/api/admin/users/${userId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                if (response.ok) {
                    setUsers(users.filter(user => user.id !== userId));
                    triggerStatus('계정이 삭제되었습니다.', 'normal');
                } else {
                    triggerStatus('삭제에 실패했습니다.', 'error');
                }
            } catch (error) {
                triggerStatus('백엔드 서버 연결 실패!', 'error');
            }
        }
    };

    const openEditModal = (user) => {
        setEditingUser({ ...user });
        setIsModalOpen(true);
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle}>
                <button onClick={() => navigate('/main')} style={backBtnStyle}>← 대시보드로 이동</button>
                <h2 style={titleStyle}>시스템 관리자 모드</h2>
            </div>

            <div style={tableWrapper}>
                <table style={tableStyle}>
                    <thead>
                    <tr style={headerRowStyle}>
                        <th style={thStyle}>ID</th>
                        <th style={thStyle}>사용자 이름</th>
                        <th style={thStyle}>이메일</th>
                        <th style={thStyle}>대학교</th>
                        <th style={thStyle}>가입일</th>
                        <th style={thStyle}>액션</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.length > 0 ? (
                        users.map((user) => (
                            <tr key={user.id} style={rowStyle}>
                                <td style={tdStyle}>{user.id}</td>
                                <td style={{...tdStyle, fontWeight: 'bold'}}>{user.name}</td>
                                <td style={tdStyle}>{user.email}</td>
                                <td style={tdStyle}>{user.university || '-'}</td>
                                <td style={tdStyle}>{user.createdAt ? (() => {
                                    if (Array.isArray(user.createdAt)) {
                                        const [y, m, d] = user.createdAt;
                                        return `${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
                                    }
                                    return typeof user.createdAt === 'string' ? user.createdAt.split('T')[0] : '-';
                                })() : '-'}</td>
                                <td style={tdStyle}>
                                    <button onClick={() => openEditModal(user)} style={editBtn}>수정</button>
                                    <button onClick={() => handleDelete(user.id)} style={delBtn}>삭제</button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{padding: '40px', color: '#999', textAlign: 'center'}}>가입된 회원이 없습니다.</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {/* 수정 모달 */}
            {isModalOpen && editingUser && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{ marginBottom: '20px' }}>회원 정보 수정</h3>
                        <div style={inputGroup}>
                            <label style={labelStyle}>ID (수정 불가)</label>
                            <input style={{...modalInput, backgroundColor: '#eee'}} value={editingUser.id} readOnly />

                            <label style={labelStyle}>이름</label>
                            <input
                                style={modalInput}
                                value={editingUser.name}
                                onChange={(e) => setEditingUser({...editingUser, name: e.target.value})}
                            />

                            <label style={labelStyle}>이메일</label>
                            <input
                                style={modalInput}
                                value={editingUser.email}
                                onChange={(e) => setEditingUser({...editingUser, email: e.target.value})}
                            />

                            <label style={labelStyle}>대학교</label>
                            <select
                                style={modalInput}
                                value={editingUser.university || ''}
                                onChange={(e) => setEditingUser({...editingUser, university: e.target.value})}
                            >
                                <option value="">대학교 선택</option>
                                <option value="한남대학교">한남대학교</option>
                                <option value="충남대학교">충남대학교</option>
                                <option value="한밭대학교">한밭대학교</option>
                            </select>
                        </div>
                        <div style={modalActions}>
                            <button onClick={handleSave} style={saveBtn}>저장</button>
                            <button onClick={() => setIsModalOpen(false)} style={cancelBtn}>취소</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ✅ 결과 알림용 커스텀 모달 */}
            {statusModal.visible && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{ marginBottom: '25px', fontSize: '18px' }}>{statusModal.message}</h3>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={() => setStatusModal({ ...statusModal, visible: false })}
                                style={{ ...saveBtn, backgroundColor: statusModal.type === 'error' ? '#ff4d4f' : '#4A90E2', maxWidth: '120px' }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// 스타일 설정 (기존 유지)
const containerStyle = { padding: '60px 20px', maxWidth: '1100px', margin: '0 auto', fontFamily: 'Pretendard, sans-serif', minHeight: '100vh' };
const headerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' };
const titleStyle = { fontSize: '24px', fontWeight: '800', margin: 0, color: '#333' };
const backBtnStyle = { padding: '10px 20px', borderRadius: '10px', border: '1px solid #ddd', backgroundColor: '#fff', cursor: 'pointer', fontWeight: '600', fontSize: '14px' };
const tableWrapper = { backgroundColor: '#fff', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #eee' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', textAlign: 'center' };
const headerRowStyle = { backgroundColor: '#f8f9fb', borderBottom: '2px solid #eee' };
const thStyle = { padding: '18px', fontSize: '14px', color: '#666', fontWeight: '700' };
const tdStyle = { padding: '18px', fontSize: '15px', borderBottom: '1px solid #f1f1f1', color: '#444' };
const rowStyle = { transition: 'background 0.2s' };
const editBtn = { padding: '8px 14px', marginRight: '8px', cursor: 'pointer', backgroundColor: '#4A90E2', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600' };
const delBtn = { padding: '8px 14px', cursor: 'pointer', backgroundColor: '#ff4d4f', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600' };
const modalOverlay = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 3000 };
const modalContent = { backgroundColor: '#fff', padding: '35px', borderRadius: '24px', width: '400px', boxShadow: '0 20px 50px rgba(0,0,0,0.15)', textAlign: 'center' };
const inputGroup = { display: 'flex', flexDirection: 'column', gap: '12px' };
const labelStyle = { fontSize: '13px', color: '#888', fontWeight: '600', marginTop: '5px', textAlign: 'left' };
const modalInput = { padding: '14px', borderRadius: '12px', border: '1px solid #ddd', fontSize: '15px', outline: 'none', boxSizing: 'border-box' };
const modalActions = { marginTop: '30px', display: 'flex', gap: '12px' };
const saveBtn = { flex: 1, padding: '14px', border: 'none', borderRadius: '12px', backgroundColor: '#4A90E2', color: '#fff', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px' };
const cancelBtn = { flex: 1, padding: '14px', border: 'none', borderRadius: '12px', backgroundColor: '#f5f5f5', color: '#666', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px' };

export default AdminPage;
